import React from 'react'
import { UseFormRegister, FieldError, Path, FieldValues } from 'react-hook-form'
import { AlertCircle } from 'lucide-react'

interface FormCheckboxProps<TFieldValues extends FieldValues> {
  label: string
  name: Path<TFieldValues>
  register: UseFormRegister<TFieldValues>
  error?: FieldError
  disabled?: boolean
  helperText?: string
  className?: string
}

export function FormCheckbox<TFieldValues extends FieldValues>({
  label,
  name,
  register,
  error,
  disabled,
  helperText,
  className,
}: FormCheckboxProps<TFieldValues>) {
  return (
    <div className={className}>
      <label className="flex items-center space-x-3 cursor-pointer">
        <input
          type="checkbox"
          disabled={disabled}
          className="form-checkbox h-5 w-5 text-brand-primary border-brand-gray/30 rounded focus:ring-brand-primary focus:ring-offset-0 bg-brand-dark"
          {...register(name)}
        />
        <span className="text-brand-gray">{label}</span>
      </label>

      {error && (
        <div className="flex items-center gap-2 mt-2 text-error text-sm">
          <AlertCircle className="w-4 h-4" />
          {error.message}
        </div>
      )}

      {helperText && !error && (
        <p className="text-xs text-brand-gray mt-1">{helperText}</p>
      )}
    </div>
  )
}
